import axios from 'axios'

export const wallet = {
    state:{
        DepositAddress:{},
        PostFund : {},
        Transactions: []
    },
    mutations:{
        DepositAddress(state,data){
            state.DepositAddress = data
            
        },
        PostFund(state,data){
            state.PostFund = data
            
        },
        Transactions(state,data){
            state.Transactions = data
            
        },
       
    },
    actions:{
        GetDepositAddress: ({commit}) => {
            return new Promise((resolve, reject)=>{
            axios.get("/getaddress")
            .then(({data, status})=>{
                if(status === 200){
                    console.log(data)
                    commit('DepositAddress', data)
                    resolve(data);
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        DepositFunds: ({commit}) => {
            return new Promise((resolve, reject)=>{
            axios.post("/postfund")
            .then(({data, status})=>{
                if(status === 200){
                    console.log(data)
                    commit('DepositAddress', data)
                    resolve(data);                    
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        GetTransactions: ({commit}) => {
            return new Promise((resolve, reject)=>{
            axios.get("/transactionhistory")
            .then(({data, status})=>{
                if(status === 200){
                    console.log(data)
                    commit('Transactions', data)
                    resolve(data);
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        
      
     }
}